import monitoring from "../assets/icons/darkIcons/monitoring.svg";
import queryStat from "../assets/icons/darkIcons/query_stat.svg";
import chat from "../assets/icons/darkIcons/barChat.svg";
import calendar from "../assets/icons/calendar.svg";

export const dataProduction = [{
    id: 1,
    title: "Temps passés par client",
    icon: calendar,
    link: "/productions/1",
    description: "Temps par collaborateur, par mois et par mission pour un client.",
  },
  {
    id: 2,
    title: "Détails d’un service",
    icon: queryStat,
    link: "/productions/2",
    description: "Commentaire et temps par collaborateur, par service et par mission.",
  },
  {
    id: 3,
    title: "Production par collaborateur",
    icon: chat,
    link: "/productions/3",
    description: "Détails des temps potentiels et réalisés par collaborateur.",
  },
  {
    id: 4,
    title: "Honoraires clients",
    icon: queryStat,
    link: "/productions/4",
    description: "Ventilation par mois des honoraires cumulés par client.",
  },
  {
    id: 5,
    title: "Facturation",
    icon: chat,
    link: "/productions/5",
    description: "Analyse des soldes restant sur les éléments facturés.",
  },
  {
    id: 6,
    title: "Production par service",
    icon: monitoring,
    link: "/productions/6",
    description: "Analyse de la production par service sur une période donnée.",
  },{
    id: 7,
    title: "Temps passé par collaborateur",
    icon: chat,
    link: "/productions/7",
    description: "Temps passé par collaborateur, par mois et par mission.",
  },
  {
    id: 8,
    title: "Feuille de temps",
    icon: calendar,
    link: "/productions/8",
    description: "Temps passé par collaborateur, par jour et par département.",
  },
  {
    id: 9,
    title: "Paiements",
    icon: queryStat,
    link: "/productions/9",
    description: "Paiements par client avec tva.",
  },{
    id: 10,
    title: "Congés et absences",
    icon: calendar,
    link: "/productions/10",
    description: "Congés et absences pour tous les collaborateurs.",
  },{
    id: 11,
    title: "Détails d’un service superviseur",
    icon: queryStat,
    link: "/productions/11",
    description: "Commentaire et temps par collaborateur, par service et par mission pour un superviseur.",
  }]

